import { EnumFeatureFlagName, FeatureFlagApiResponse } from '@blank/api'
import { useQuery } from '@tanstack/react-query'
import { COUNTRY_API_BASE_URL_MAP } from 'modules/common/http/apiClient'
import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import { EnumUserLocale, USER_COUNTRY_MAP } from 'modules/common/types/locale'
import { QueryOptions } from 'modules/auth/types/queries'
import { fetchFeatureFlag } from '../api/fetchFeatureFlag'
import { EnumCorporateQueryKeys } from './keys'

const getApiBaseUrlForLocale = (locale: EnumUserLocale) => {
  const country = USER_COUNTRY_MAP[locale]
  return COUNTRY_API_BASE_URL_MAP[country]
}

export const useFeatureFlagQuery = (
  featureName: EnumFeatureFlagName,
  queryOptions?: QueryOptions<{ body: FeatureFlagApiResponse }, Error>
) => {
  const userLocale = useUserLocale()
  const baseURL = getApiBaseUrlForLocale(userLocale)

  return useQuery<{ body: FeatureFlagApiResponse }, Error>({
    queryKey: [EnumCorporateQueryKeys.FEATURE_FLAG, featureName, baseURL],
    queryFn: () => fetchFeatureFlag({ featureName, baseURL }),
    ...queryOptions,
  })
}
